import { features } from '@/mocks/homeData';

export default function Features() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">
              为什么选择我们
            </h2>
            <p className="text-sm text-foreground-500 mt-2 max-w-xl mx-auto">
              四个维度告诉你，为什么911吃瓜网是吃瓜群众的最佳选择
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            {features.map((item) => (
              <div
                key={item.title}
                className="bg-background-50 rounded-xl p-6 md:p-7 text-center group hover:bg-primary-50/30 transition-colors duration-300"
              >
                <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-4 flex items-center justify-center rounded-2xl bg-accent-100 text-accent-600 group-hover:bg-accent-200 transition-colors duration-300">
                  <i className={`${item.icon} text-2xl`}></i>
                </div>
                <h3 className="font-heading text-lg text-foreground-800 mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}